import { useContext } from 'react';
import { BmoTransactionsTableContext, IBmoTransactionsTableContext } from './BmoTransactionsTableContext';

export const useBmoTransactionsTable = () => useContext<IBmoTransactionsTableContext>(BmoTransactionsTableContext);
